export type MsalProfilePermissions = {}

export const useMsalProfilePermissions = (): MsalProfilePermissions => {
  return {}
}
